import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import { GRAY_LIGHTER, GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_BOLD } from '../../styles/variables';
import Delivery from '../../images/icon-delivery.svg';
import Takeaway from '../../images/icon-takeaway.svg';

export const DescribeProducts = styled.div`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  ${flexPosition({ align: 'center', justify: 'space-around' })}
    text-transform: uppercase;
  margin-left: 10px;
  border: 1px solid ${GRAY_LIGHTER};
  border-radius: 30px;
  padding: 7px 12px;
  width: 120px;
`;

export const IconDelivery = styled.span`
  width: 30px;
  height: 30px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${Delivery});
  ${props =>
    props.active
      ? `
        filter: none;
        opacity: 1;
    `
      : `filter: grayscale(100%);
     opacity: 0.5;`}
`;

export const IconIndoor = styled(IconDelivery)`
  background-image: url(${Takeaway});
`;



// WEBPACK FOOTER //
// ./src/components/MenuTag/style.js